import { useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import * as docx from "docx-preview"
import { useDispatch } from "react-redux"
import { showToastMessage } from "../../../stateManagement/reducers"
import { Loader } from "../../loaders/Loader"
import { fetchDocumentView } from "../../../api/documentsApi"

export default function CustomDocumentViewerDOCX() {
    const dispatch = useDispatch()
    const { documentId }: any = useParams()
    const [documentIsLoading, setDocumentIsLoading] = useState<boolean>(true)
    const docxViewerDivId = "document-docx-viewer-div"

    async function getDocumentFile() {
        setDocumentIsLoading(true)
        const file = await fetchDocumentView(documentId)
        if (file) {
            if (file instanceof Blob) {
                let element: any = document.getElementById(docxViewerDivId)
                var options = { inWrapper: true, ignoreWidth: false, pageBreaks: true, ignoreLastRenderedPageBreak: true }
                docx.renderAsync(file, element, undefined, options)
            } else {
                dispatch(showToastMessage({ messageText: "Возникла ошибка при загрузке документа для просмотра", messageType: "error" }))
            }
        }
        setDocumentIsLoading(false)
    }

    useEffect(() => {
        getDocumentFile()
    }, [documentId])

    return (
        <>
            {documentIsLoading && <Loader />}
            <div id={docxViewerDivId} />
        </>
    )
}
